import React from 'react';
import { useTranslation } from '../hooks/useTranslation';
import {
  Cog6ToothIcon,
  AdjustmentsHorizontalIcon,
  PhotoIcon,
  SwatchIcon,
  SparklesIcon,
  PaintBrushIcon,
} from '@heroicons/react/24/outline';

/**
 * Barra de navegação mobile no footer
 * Mostra as opções: Geral, Ajustes, Filtros, Cores, Efeitos, Pintura
 */
const MobileTabBar = ({ activeTab, onTabChange, disabled = false, isBaseLayerSelected = false }) => {
  const { t } = useTranslation();

  const tabs = [
    {
      id: 'geral',
      icon: Cog6ToothIcon,
      label: t('tabs.general'),
      disabled: false,
    },
    {
      id: 'ajustes',
      icon: AdjustmentsHorizontalIcon,
      label: t('tabs.adjustments'),
      disabled: !disabled && isBaseLayerSelected,
    },
    {
      id: 'filtros',
      icon: PhotoIcon,
      label: t('tabs.filters'),
      disabled: !disabled && isBaseLayerSelected,
    },
    {
      id: 'cores',
      icon: SwatchIcon,
      label: t('tabs.colors'),
      disabled: !disabled && isBaseLayerSelected,
    },
    {
      id: 'efeitos',
      icon: SparklesIcon,
      label: t('tabs.effects'),
      disabled: !disabled && isBaseLayerSelected,
    },
  ];

  return (
    <div className="md:hidden border-t border-gray-800 shadow-lg" style={{ backgroundColor: '#101f00' }}>
      <div className="flex items-center justify-around">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;
          const isDisabled = disabled || tab.disabled;

          return (
            <button
              key={tab.id}
              onClick={() => !isDisabled && onTabChange(tab.id)}
              disabled={isDisabled}
              className={`flex-1 flex items-center justify-center py-3 px-1 transition-colors ${
                isDisabled
                  ? 'opacity-30 cursor-not-allowed'
                  : isActive
                  ? 'bg-[#7eb715]'
                  : 'hover:bg-gray-800'
              }`}
              title={tab.label}
            >
              <Icon className={`w-5 h-5 ${isActive ? 'text-black' : 'text-[#7eb715]'}`} />
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default MobileTabBar;


